import { ID } from '@models';
import useFetch from '@hooks/useFetch';
import { useEffect, useMemo, useState } from 'react';
import { components } from '@api/api';
import { iItem, Item } from '@models/Item';
import { useCategoryActivityFilters } from '@core/selectors/useCategoryActivityFilters';
import { useUserContext } from "@core/UserContext";

type Request = components['schemas']['CategoryLaunchesRequest'];
type Response = components['schemas']['CategoryLaunchesRecentlyReleasedItemsResponse'];

export function useCategoryActivityRecentlyReleasedItems(categoryId: ID) {
    const { uiSettings: { currencySymbol }} = useUserContext();
    const [data, setData] = useState<iItem[]>([]);

    const filter = useCategoryActivityFilters();

    const payload = useMemo((): Request => {
        return {
            filter,
            id: categoryId as number,
        };
    }, [filter, categoryId]);

    const result = useFetch<Response>({
        url: '/api/Category/RecentlyReleasedItems',
        method: 'post',
        payload,
    });

    useEffect(() => {
        if (!result.isLoading) {
            setData((result.data?.items || []).map(i => new Item({ apiModel: i, currencySymbol })))
        }
    }, [result.isLoading, result.data, currencySymbol]);

    return {
        isLoading: result.isLoading,
        data,
    }
}